
<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
  {{'alert.signature_process_contract' | translate}}
  <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider class="mb-2"></mat-divider>
<ng-container *ngIf="subTitle">
  <span [innerHTML]="subTitle | translate" class="subtitle"></span>
</ng-container>
<div class="row" style="margin: 0px; padding: 0px;">
  <div class="col-12" style="margin: 0px; padding: 0px;top: 10px;" *ngIf="!isProcess">
    <mat-dialog-content>
      <div class="popup-content" >
        <div class="row">
          <div class="col-3">
            <label class="mat-dialog-title" style="margin-top: 5px;font-size: 15px">{{'title.signature_process' | translate}}<span style="color: red">*</span></label>
          </div>
          <div class="col-7" style="margin-left: -90px;">
            <nz-input-group [nzSuffix]="suffixUserInput">
              <input nz-input [(ngModel)]="inputUserValue" (input)="onChangeUserSignSearch($event.target.value)"
                     [nzAutocomplete]="autoUserSearching" [ngModelOptions]="{ standalone: true }"
                     placeholder="{{'placeholder.name_and_email' | translate}}"/>
              <nz-autocomplete #autoUserSearching>
                <nz-auto-option *ngFor="let user of filteredUserOptions"
                                (selectionChange)="autocompleteUserSelected($event, user)" [nzValue]="''">{{user.name}}
                  - {{user.email}} <span *ngIf="user.userPosition">- {{ user.userPosition}}</span></nz-auto-option>
              </nz-autocomplete>
            </nz-input-group>
            <ng-template #suffixUserInput>
              <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
            </ng-template>
            <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                style="font-size: 24px;"></i></ng-template>
          </div>
        </div>
      </div>

    </mat-dialog-content>
  </div>
  <div *ngIf="newInitialInfo.name " class="col-12" style="margin: 0px; padding: 0px;top: 10px;">
    <p class="mat-dialog-title" style="font-size: 15px;">{{ 'enterprise_contract.panel_document_view.table_information_signed.header.member' | translate }} : <span style="color: red">{{newInitialInfo.name}}</span> ({{newInitialInfo.email}} - {{newInitialInfo.phone}} <span *ngIf="newInitialInfo.userPosition">- {{ newInitialInfo.userPosition}}</span>)</p>
  </div>
  <div  class="col-12" style="margin: 0px; padding: 0px;top: 10px;">
    <label class="mat-dialog-title" style="font-size: 15px;" >{{'messages.title_lot_process_1' | translate}} <span style="color: red;font-weight: bold;">{{listDataPopup.length}}</span> {{'messages.title_lot_process_2' | translate}}</label>
  </div>
  <div class="col-12" style="margin: 0px; padding: 0px;top: 10px;">
    <div class="mat-table-container scroll-table">
      <span *ngIf="isShowProgress" class="mx-3 mat-panel-title" style="border: none !important;">{{'search_form.processing' | translate}} {{percent}}%</span>
      <mat-progress-bar *ngIf="isShowProgress" mode="determinate" color="primary" [bufferValue] = "100" [value] = "percent">
      </mat-progress-bar>
      <mat-table [dataSource]="listData" class="mat-table-col-extra-sm">
        <!-- check -->
        <ng-container matColumnDef="STT">
          <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
            {{'enterprise_contract.table_headers.No' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element;let i = index" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                    (click)="$event.stopPropagation()">
            {{element.order}}
          </mat-cell>
        </ng-container>

        <!-- Full name -->
        <ng-container matColumnDef="contractDocument">
          <mat-header-cell *matHeaderCellDef style="max-width: 25%;" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
            {{'headertable.contract_document' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="max-width: 25%;">
                        <span matTooltip="{{element.contractName ? element.contractName : element.contractNameCode}}" class="fix-width" style="margin-left: -5px;">
          {{element.contractName ? element.contractName  : element.contractNameCode}}
        </span>
          </mat-cell>
        </ng-container>

        <!-- Khach hang/noi bo -->
        <ng-container matColumnDef="userName">
          <mat-header-cell *matHeaderCellDef  class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="max-width: 20%;">
            {{'headertable.name_of_subject_to_be_confirmed' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="max-width: 20%;">
                        <span matTooltip="{{element.signerName}}" class="fix-width" style="margin-left: -5px;">
          {{element.signerName}}
        </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="result">
          <mat-header-cell *matHeaderCellDef style="max-width: 15%;" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                        <span>
          {{'headertable.result' | translate}}
        </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" style="max-width: 15%;"
                    (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom">
            <span class="fix-width text-center" [ngStyle]="renderStatusColor(element.statusName)">{{renderStatus(element.statusName)}}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="detail">
          <mat-header-cell *matHeaderCellDef >
                        <span>
          {{'view_document_information.table_headers.partiesSignContract.action' | translate}}
        </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" matTooltip="{{ !isShowProgress ? element.errorMessage  : '' }}"
                    (click)="$event.stopPropagation()" >
            <span class="fix-width">{{element.errorMessage ? element.errorMessage : ''}}</span>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row">
        </mat-row>
      </mat-table>
    </div>
    <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)">
    </app-pagination>
    <mat-dialog-actions align="center" style="    margin-top: -10px;" class="">
      <button *ngIf="!isProcess" mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.cancel' | translate}}
      </button>
      <button *ngIf="!isProcess " [disabled]="newInitialInfo.name?false:true"  mat-raised-button cdkFocusInitial (click)="onClickConfirmButton()" color="primary">
        <mat-icon class="mr-0">done_all</mat-icon>
        {{'button.confirm' | translate}}
      </button>
      <!-- đóng popup -->
      <button *ngIf="isProcess" mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.close' | translate}}
      </button>

      <!-- dừng ký -->
      <button *ngIf="isProcess" mat-stroked-button color="primary" class="mr-3" (click)="onClickStopSign()" type="button"
              [disabled] = "isStop">
        <mat-icon class="mr-0">block</mat-icon>
        {{'button.stop_progress' | translate}}
      </button>
    </mat-dialog-actions>
  </div>
</div>

